import { getRolesByName } from '../api/role'
import type { Resolvers } from '../generated/server/resolvers'

const RoleResolver: Resolvers = {
  Query: {
    getRolesByName: (_, { roleNames }) => getRolesByName(roleNames),
  },
}

export default RoleResolver
